import { matchPath } from 'react-router';
import { call, select, put, takeEvery, delay } from 'redux-saga/effects';

import { META_SOURCE_UPLOAD } from 'constants/ReleaseConstants';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import { UPLOAD_MEDIAS_SUCCESS } from 'modules/medias/actionTypes';
import { fetchReleaseById } from 'modules/releases/actions/core';
import { closeNoteCsvModal } from 'modules/releases/actions/details';
import { DETAILS_SOURCE } from 'modules/releases/constants';
import { getDetailsRelease } from 'modules/releases/selectors/details';
import { getLocation } from 'modules/router/selectors';
import { createNotification } from 'modules/toast-notifications/actions';

// 2 seconds
const FAKE_DELAY = 2000;

function* initDetailsPage() {
  const location = yield select(getLocation);
  const match = matchPath(PATH.RELEASES_DETAILS.path, location.pathname);
  const { releaseId } = match.params;

  yield put(fetchReleaseById(releaseId, { source: DETAILS_SOURCE }));
}

function* initializeReleaseDetails() {
  yield call(initDetailsPage);
}

// Add a websocket to refresh the version details page once the API has finished processing the file.
function* afterUploadedDocuments() {
  const release = yield select(getDetailsRelease);
  yield delay(FAKE_DELAY);
  yield put(closeNoteCsvModal());
  const { error } = yield putAndWait(fetchReleaseById(release.id));
  if (!error) {
    yield put(
      createNotification({
        type: 'success',
        message: {
          id: 'page.releases.update.success',
          defaultMessage: 'The release note has been updated successfully.',
        },
      })
    );
  }
}

const uploadedDocumentMatcher = ({ type, meta }) => type === UPLOAD_MEDIAS_SUCCESS && meta.source === META_SOURCE_UPLOAD;

/**
 * Details saga scoped to the releases details page
 */
export default function* detailsSaga() {
  yield scopeToPage([PATH.RELEASES_DETAILS], initializeReleaseDetails);
  yield takeEvery(uploadedDocumentMatcher, afterUploadedDocuments);
}
